// Where we are in the homecoming plan: days before pick-up, pick-up day,
// the first night, and days 1–7.

import { HOMECOMING, type PlanSection } from '../content/homecoming.ts';
import { daysBetween, today } from './time.ts';
import type { Millis } from './types.ts';

/** Days since pick-up day (negative before it), or undefined without a date. */
export function planDay(homeDate: string | undefined, now: Millis): number | undefined {
  return homeDate ? daysBetween(homeDate, today(now)) : undefined;
}

/** The first week (pick-up day through day 7) — when Today shows the plan. */
export function inWeekOne(day: number | undefined): boolean {
  return day !== undefined && day >= 0 && day <= 7;
}

/** The sections that matter right now. Pick-up day switches to the first night from 5pm. */
export function currentSections(day: number | undefined, now: Millis): PlanSection[] {
  if (day === undefined) return [];
  if (day < 0) return day >= -14 ? HOMECOMING.filter((s) => s.id === 'prep') : [];
  if (day === 0) return new Date(now).getHours() >= 17 ? HOMECOMING.filter((s) => s.id === 'night1') : HOMECOMING.filter((s) => s.id === 'pickup' || s.id === 'breeder');
  return HOMECOMING.filter((s) => s.day === day);
}
